'use client';

import { FC, useContext, useCallback, useState } from 'react';
import { SendTemplateDialog, Dialog, Flex } from '@/_components';
import { SendQuestionnaireDialogProps } from './SendQuestionnaireDialog.types';
import { QuestionnaireContext } from '../../QuestionnaireProvider';
import { SendQuestionnaireItem } from './components/SendQuestionnaireItem';
import { SendCustomQuestionnaireDialog } from './components/SendCustomQuestionnaireDialog';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import { SendDocumentDropOffDialog } from './components/SendDocumentDropOffDialog';

export const SendQuestionnaireDialog: FC<SendQuestionnaireDialogProps> = ({
  preselectedEntityIds,
}) => {
  const { isSending, setSending, isSendingTemplate, setSendingTemplate } =
    useContext(QuestionnaireContext);
  const { preferences } = useContext(FirmSettingsContext);
  const [isSendingDocumentDropOff, setSendingDocumentDropOff] =
    useState<boolean>(false);

  const [isSendingCustom, setSendingCustom] = useState<boolean>(false);

  const onCloseDialogs = () => {
    setSendingCustom(false);
    setSending(false);
    setSendingTemplate(false);
  };

  const onTemplateClick = useCallback(() => {
    setSending(false, preselectedEntityIds);
    setSendingTemplate(true);
  }, [preselectedEntityIds, setSending, setSendingTemplate]);

  const onCustomClick = () => {
    setSending(false);
    setSendingCustom(true);
  };

  const onDocumentDropOffToggle = () => {
    setSending(false, preselectedEntityIds);
    setSendingDocumentDropOff(!isSendingDocumentDropOff);
  };

  return (
    <>
      <SendCustomQuestionnaireDialog
        isOpen={isSendingCustom}
        onClose={onCloseDialogs}
        initiallySelectedCompanyIds={preselectedEntityIds}
      />
      <SendDocumentDropOffDialog
        isOpen={isSendingDocumentDropOff}
        onClose={onDocumentDropOffToggle}
        initiallySelectedCompanyIds={preselectedEntityIds}
      />
      <SendTemplateDialog
        isOpen={isSendingTemplate}
        onClose={onCloseDialogs}
        initiallySelectedCompanyIds={preselectedEntityIds}
      />
      <Dialog
        isOpen={isSending}
        isWide={!!preferences?.document_drop_off_enabled}
        onClose={onCloseDialogs}
        title="Send Questionnaire"
      >
        <Dialog.Content>
          <Flex gap={6} padding={6} isWrapping={true}>
            <SendQuestionnaireItem
              onClick={onTemplateClick}
              icon="file"
              title="Template"
              description="List of previously customized questions. Edit templates in Questionnaire Templates page."
            />
            {preferences?.document_drop_off_enabled && (
              <SendQuestionnaireItem
                onClick={onDocumentDropOffToggle}
                icon="sparkle"
                title="Document Drop Off"
                description="A simple document request using rollover items without signing in."
              />
            )}
            <SendQuestionnaireItem
              icon="gear-fine"
              onClick={onCustomClick}
              title="Custom"
              description="Custom list of questions and items you need from your clients."
            />
          </Flex>
        </Dialog.Content>
      </Dialog>
    </>
  );
};
